import React, { useRef } from 'react'
import { Modal, Row } from 'react-bootstrap'
import styled from 'styled-components'
import { fixedAssets } from 'src/containers/PreCache'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Pagination, Scrollbar, A11y, Zoom, EffectCoverflow } from 'swiper'
import { SIZES } from 'src/styles/theme'

const StyledModal = styled(Modal)`
  .modal-dialog {
    min-width: 75%;
  }
  .modal-content {
    border: none;
    background: transparent;
    border-radius: 0;
    padding: 0px 36px;
    margin-bottom: 24px;
  }
  .modal-header {
    border: none;
    text-align: left;
    padding: 0 !important;
    .modal-title {
      font-size: 36px;
      font-weight: bold;
      font-style: italic;
    }
    button {
      font-weight: 400 !important;
      font-size: 54px;
      opacity: 1;
      color: rgba(255, 255, 255, 0.55);
    }
  }
  .header-section {
    margin-bottom: 1rem;
    .navigation {
      height: 100%;
      width: 80%;
      margin: 0 auto;
      display: flex;
      justify-content: space-around;
      align-items: flex-end;
      .animated-btn {
        background: linear-gradient(125deg, #b98316, #fef1a0, #b98316);
        color: #000;
        font-size: 15px;
        font-weight: 600;
        ${SIZES.mobile} {
          font-size: 10px;
          font-weight: 500;
          width: 100px;
          line-height: 30px;
          height: 30px;
        }
      }
    }
  }
  .back-top {
    border: none;
    border-radius: 50%;
    background: linear-gradient(125deg, #b98316, #fef1a0, #b98316);
    position:absolute;
    padding: 0;
    bottom: 0;
    right: 0;
    svg {
      width:50;
      height:50;
    }
    &:hover {
      transition: all 300ms;
      transform: scale(1.1);
    }
  }
  .modal-body {
    padding-top: 0 !important;
    padding-bottom: 36px;
  }
  ${SIZES.mobile} {
    .modal-content {
      padding: 0px;
      background: #fff;
    }
    .modal-header {
      button {
        font-size: 30px;
        color: rgba(0, 0, 0, 0.55);
      }
    }
  }
`

const slides = [fixedAssets.slide1, fixedAssets.slide2, fixedAssets.slide3, fixedAssets.slide4, fixedAssets.slide5, fixedAssets.slide6, fixedAssets.slide7, fixedAssets.slide8, fixedAssets.slide9, fixedAssets.slide10]

export default function AgendaSpeakersModal({ showModal, hideModal }) {
  const startModal = useRef()
  const speakerSec = useRef()
  const agendaSec = useRef()

  const scrollTop = (ref) =>{
    ref.current.scrollIntoView({ behavior: 'smooth' })
  };

  return (
    <StyledModal
      show={showModal}
      onHide={hideModal}
      size="lg"
      aria-labelledby="agenda-speakers"
      centered
    >
      <Modal.Header closeButton>
        <span ref={startModal}></span>
      </Modal.Header>

      <Modal.Body>
        <Row className="header-section" noGutters>
          <div className="navigation">
            <div className='animated-btn' onClick={()=>scrollTop(startModal)}>
              <span>Objective</span>
            </div>
            <div className='animated-btn' onClick={()=>scrollTop(agendaSec)}>
              <span>Agenda</span>
            </div>
            <div className='animated-btn' onClick={()=>scrollTop(speakerSec)}>
              <span>Speakers</span>
            </div>
          </div>
        </Row>

        <div>
          <img src={fixedAssets.objective} width="100%" alt="event objective"/>
        </div>
        
        <br />
        <span ref={agendaSec}></span>
       
        <Swiper
            className='mySwiper'
            modules={[Navigation, Pagination, Scrollbar, A11y, Zoom, EffectCoverflow]}
            navigation={true}
            slidesPerView={1}
            effect="coverflow"
            zoom={true}
            pagination={{ 
              clickable: true,
              renderBullet: function (index, className) {
                return '<span class="' + className + '">' + (index + 1) + "</span>";
              },
            }}
          >
          {[fixedAssets.day1, fixedAssets.day2].map((agenda,index)=>(
            <SwiperSlide key={`agenda-${index}`} zoom={true} control={true}>
              <img className="d-block" src={agenda} alt={`agenda-${index}`} width="100%" />
            </SwiperSlide>
          ))}
        </Swiper>
        <br />
        <span ref={speakerSec}></span>

        <Swiper
          className='mySwiper'
          modules={[Navigation, Pagination, Scrollbar, A11y, Zoom, EffectCoverflow]}
          navigation={true}
          slidesPerView={1}
          effect="coverflow"
          zoom={true}
          pagination={{ 
            clickable: true,
            renderBullet: function (index, className) {
              return '<span class="' + className + '">' + (index + 1) + "</span>";
            },
          }}
          scrollbar={{ draggable: true }}
        >
          {slides.map((agenda,index)=>(
            <SwiperSlide key={`agenda-${index}`} zoom={true}>
              <img className="d-block" src={agenda} alt={`agenda-${index}`} width="100%" />
            </SwiperSlide>
          ))}
        </Swiper>

        <br />

        <button onClick={()=>scrollTop(startModal)} className="back-top">
          <svg width="45" height="45" viewBox="0 0 45 45">
            <g transform="translate(-1767 -3747)">
              <g transform="translate(120 -2428)">
                <path d="M22.175,9.358a1.43,1.43,0,0,0-1.43-1.43H5.063l5.813-5.42A1.43,1.43,0,1,0,8.923.421L.455,8.311a1.43,1.43,0,0,0,0,2.091L8.923,18.3A1.43,1.43,0,1,0,10.875,16.2L5.063,10.788H20.746A1.43,1.43,0,0,0,22.175,9.358Z" transform="translate(1678.681 6187) rotate(90)" fill="#000"/>
              </g>
            </g>
          </svg>
        </button>
      </Modal.Body>
    </StyledModal>
  )
}
